module.exports = __webpack_public_path__ + "941a7e42ec26efbf6e8aa0f21590bcfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_30.jpg
// module id = 1741
// module chunks = 5